"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirksGambitAbilityHandler = exports.DirksGambitActorAbilityFactory = exports.DirksGambitAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const HotStreak_1 = require("../../core/effects/core/HotStreak");
const Demand_1 = require("../../core/Demand");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const core_2 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
class DirksGambitAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.DirksGambit;
        this.__typeName = "DirksGambit";
    }
}
exports.DirksGambitAbilityArgs = DirksGambitAbilityArgs;
let DirksGambitActorAbilityFactory = class DirksGambitActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("DirksGambit", "OneAllies", 3);
    }
};
DirksGambitActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("DirksGambit")
], DirksGambitActorAbilityFactory);
exports.DirksGambitActorAbilityFactory = DirksGambitActorAbilityFactory;
let DirksGambitAbilityHandler = class DirksGambitAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedAlly] = ability.args.target.actorIds;
        (0, Demand_1.demand)(ability.invokerId !== selectedAlly, "CANNOT_TARGET_SELF");
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedAlly, "feet"), "EngulfingDarkness"));
                if (!container.testAttribute(ability.invokerId, "Luck", 1)) {
                    container.applyEffect(sequence, ability.invokerId, selectedAlly, new core_2.DeathEffectArgs());
                }
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .filter(allyId => allyId !== ability.invokerId)
                    .forEach(allyId => {
                    container.applyBuff({
                        sequence,
                        creatorId: ability.invokerId,
                        targetId: allyId,
                        duration: Duration_1.Duration.Permanent,
                        effect: new core_2.LinkedEffectsEffectArgs([
                            new HotStreak_1.HotStreakEffectArgs(30, true),
                            new core_2.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Toughness, container.getPercentOfBaseAttributeScore(allyId, 25, "Toughness")),
                            new core_2.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Will, container.getPercentOfBaseAttributeScore(allyId, 25, "Will")),
                        ], false),
                        onApplied: sequence => sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(allyId, "feet", "behind"), "FireMagicCircle"))
                    });
                });
            }
        });
    }
};
DirksGambitAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.DirksGambit)
], DirksGambitAbilityHandler);
exports.DirksGambitAbilityHandler = DirksGambitAbilityHandler;
